import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';

import { Photo } from 'src/app/core/services/clubs/club.model';

@Component({
  selector: 'app-club-media-photos-section',
  templateUrl: './club-media-photos-section.component.html',
  styleUrls: ['./club-media-photos-section.component.scss']
})
export class ClubMediaPhotosSectionComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() photos: Photo[];

  @ViewChild('photosEl', { read: ElementRef }) photosEl: ElementRef;

  @Output() startLoading = new EventEmitter<void>();
  @Output() loaded = new EventEmitter<void>();
  @Output() remove = new EventEmitter<number>();
  @Output() select = new EventEmitter<number>();

  private _amountOfLoaded$ = new BehaviorSubject(null);
  private _componentDestroy$ = new Subject();

  ngOnInit() {
    this._amountOfLoaded$
      .pipe(
        takeUntil(this._componentDestroy$),
        filter((_) => _ === this.photos?.length),
        tap((_) => this._loaded())
      )
      .subscribe((_) => _);
  }

  ngAfterViewInit() {
    this._startLoading();
  }

  ngOnDestroy() {
    this._componentDestroy$.next();
    this._componentDestroy$.complete();
  }

  onLoad() {
    this._amountOfLoaded$.next(this._amountOfLoaded$.value + 1);
  }

  onError() {
    this._amountOfLoaded$.next(this._amountOfLoaded$.value + 1);
  }

  onRemove(id: number) {
    this.remove.emit(id);
  }

  onSelect(id: number) {
    this.select.emit(id);
  }

  private _startLoading() {
    this.photosEl.nativeElement.style.display = 'none';
    this.startLoading.emit();
  }

  private _loaded() {
    this.photosEl.nativeElement.style.display = 'flex';
    this.loaded.emit();
  }
}
